export default {"src":"/_next/static/media/TV_multiscreen.d0eb8ba6.svg","height":192,"width":192};